import { render, staticRenderFns } from "./StatsOnlineUser.vue?vue&type=template&id=18ed3464&"
import script from "./StatsOnlineUser.vue?vue&type=script&lang=js&"
export * from "./StatsOnlineUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports